var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppListItemNavigateTo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.28877 19.0943C7.90374 18.7038 7.90374 18.0706 8.28877 17.6801L13.5071 12.3872L8.28877 7.09431C7.90374 6.70379 7.90374 6.07062 8.28877 5.6801C8.67379 5.28958 9.29804 5.28958 9.68306 5.6801L15.5986 11.6801C15.9836 12.0706 15.9836 12.7038 15.5986 13.0943L9.68306 19.0943C9.29804 19.4848 8.67379 19.4848 8.28877 19.0943Z",
    fill: "#828282"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppListItemNavigateTo);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNCAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTguMjg4NzcgMTkuMDk0M0M3LjkwMzc0IDE4LjcwMzggNy45MDM3NCAxOC4wNzA2IDguMjg4NzcgMTcuNjgwMUwxMy41MDcxIDEyLjM4NzJMOC4yODg3NyA3LjA5NDMxQzcuOTAzNzQgNi43MDM3OSA3LjkwMzc0IDYuMDcwNjIgOC4yODg3NyA1LjY4MDFDOC42NzM3OSA1LjI4OTU4IDkuMjk4MDQgNS4yODk1OCA5LjY4MzA2IDUuNjgwMUwxNS41OTg2IDExLjY4MDFDMTUuOTgzNiAxMi4wNzA2IDE1Ljk4MzYgMTIuNzAzOCAxNS41OTg2IDEzLjA5NDNMOS42ODMwNiAxOS4wOTQzQzkuMjk4MDQgMTkuNDg0OCA4LjY3Mzc5IDE5LjQ4NDggOC4yODg3NyAxOS4wOTQzWiIgZmlsbD0iIzgyODI4MiIvPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };